import { useMemo } from 'react';
import {
  BlueberryFlowerStageFeatures,
  FeatureEnum,
} from '../../../services/data/impl/cube/cubeSlice';
import { useBlueberryConfig } from '../../dataMesh/blueberry/hooks/useBlueberryConfig';

export const useBlueberryFlowerFeatures = () => {
  const blueberryConfig = useBlueberryConfig();

  const includeFlowers = blueberryConfig?.includeFlowers;
  const hasFlowerStages = blueberryConfig?.hasFlowerStages;

  const availableFlowerFeatures = useMemo(() => {
    if (!includeFlowers) return [] as FeatureEnum[];
    if (!hasFlowerStages) return [FeatureEnum.flower];
    return BlueberryFlowerStageFeatures;
  }, [includeFlowers, hasFlowerStages]);

  return availableFlowerFeatures;
};
